module.exports = __webpack_public_path__ + "images/new_capture/capture-intro@2x-ff8cc89a1e1da76a7bbee2b067f998c6.png";